import * as types from '../mutation-types';
import { unionState } from '../union-state'
const state = () => ({
	users: [],
	permissionUser: []
})

const actions = {
	fetchAll({ commit }) {
		return window.axios.get('Users').then(response => {
            commit(types.STORE_USERS, response.data)
            return response.data;
		})
	},
    fetchUser({ commit }, id) {
		return window.axios.get(`Users/${id}`).then(response => {
			commit(types.STORE_ONE_USER, response.data)
			return response.data;
		});
	},
    fetchPermissions(vuexContext, { id }) {
		return window.axios.get(`Users/${id}/Permissions`).then(response => {
            return response.data;
		})
	},
    create(vuexContext, { userName, password, canCreateFinancialFile, roleId, isActive, isAdmin }) {
		return window.axios.post(`Users`, {
			user_name: userName, password, canCreateFinancialFile, roleId, isActive, isAdmin	
		}).then(response => {
			// commit(types.STORE_ONE_USER, response.data)
			return response.data;
		});
	},
    // update(vuexContext, { id, userName, password, canCreateFinancialFile, roleId, isActive, isAdmin }) {
	// 	return window.axios.put(`Users/${id}`, {
    //         id,
	// 		user_name: userName, 
	// 		password, 
	// 		canCreateFinancialFile, 
	// 		roleId, 
	// 		isActive, 
	// 		isAdmin
	// 	}).then(response => {
	// 		// commit(types.STORE_ONE_USER, response.data)
	// 		return response.data;
	// 	});
	// },
    update(vuexContext, { id, userName, password, canCreateFinancialFile, roleId }) {
		return window.axios.put(`Users/${id}`, {
            role_id: roleId,
			new_password: password,
			new_username: userName,
			can_create_financial_file: canCreateFinancialFile
		}).then(response => {
			return response.data;
		});
	},
	
	changePassword(vuexContext, { old_password, new_password, new_password_repeated }) {
        return axios.put('Users/me/ChangePassword', { old_password, new_password, new_password_repeated }).then(response => {
            return response.data
        })
    },
	changeLanguage(vuexContext, { language }) {
        return axios.put('Users/me/ChangeLanguage', { language }).then(response => {
            return response.data
        })
    },
    delete(vuexContext, id) {
		return window.axios.delete(`Users/${id}`).then(response => {
			// commit(types.DELETE_USER, response.data)
			return response.data;
		});
	},

    changeStatus(vuexContext, { id }) {
		return window.axios.put(`Users/Toggle/${id}`
        ).then(response => {
			// commit(types.STORE_ONE_USER, response.data)
			return response.data;
		});
	},
}
const getters = {
	getUserById: state => id => state.users.find(t => t.id === id),
};
const mutations = {
    [types.STORE_USERS](state, users) {
		state.users = users;
	},
    [types.STORE_ONE_USER](state, user) {
		state.users = unionState(state.users, [user]);
	},
    [types.DELETE_USER](state, user) {
		state.users = unionState(state.users, [user]);
	},
	[types.STORE_PERMISSION](state, permissionUser) {
		state.permissionUser = permissionUser
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

